export { HttpRequest } from './httpRequest'
export { Batch } from './batch'
export { canUseEventBridge, getEventBridge, BrowserWindowWithEventBridge } from './eventBridge'
export { startBatchWithReplica } from './startBatchWithReplica'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-core/src/transport/index.ts